class ShippingCaculator extends HTMLElement {
	constructor() {
		super();

    this.needEndLoading = false;
    this.showingErrors = false;
		this.button = this.querySelector('button');
		this.addressCountrySelect = this.querySelector('#AddressCountryCalculator');
		this.addressProvinceSelect = this.querySelector('#AddressProvinceCalculator');
		this.addressZipInput = this.querySelector('#AddressZipCalculator');
    this.resultsTag = this.querySelector('.shipping-calculator__results');
    this.resultsList = this.querySelector('.shipping-calculator__results-list');
    this.resultsErrorHeading = this.querySelector('.shipping-calculator__error-heading');
    this.resultsSuccessHeading = this.querySelector('.shipping-calculator__success-heading');

    // Delhivery API configuration
    this.DELHIVERY_API_TOKEN = '6295351002af6cc182491e28b9ab6cb131c4a6a8';
    this.ORIGIN_PIN = '144001';
    this.AVERAGE_PICKUP_DAYS = 1;
    this.debug = true;

    this.button.addEventListener('click', this.onButtonClick.bind(this));
    this.addEventListener('change', this.hideErrorsTag.bind(this), false);
	}

  connectedCallback() {
    this.setupCountries();
  }

	setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(this.addressCountrySelect.id, this.addressProvinceSelect.id, {
        hideElement: 'AddressProvinceContainerCalculator'
      });
    }
  }

  serialize(obj, prefix) {
	  var str = [], p;
	  for (p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      var k = prefix ? prefix + "[" + p + "]" : p,
	        v = obj[p];
	      str.push((v !== null && typeof v === "object") ?
	        this.serialize(v, k) :
	        encodeURIComponent(k) + "=" + encodeURIComponent(v));
	    }
	  }
	  return str.join("&");
	}

  startLoading() {
    this.needEndLoading = false;
    this.button.setAttribute('aria-disabled', true);
    this.button.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  endLoading() {
    if(this.needEndLoading) {
      // Run end loading action
      this.needEndLoading = false;
      this.button.setAttribute('aria-disabled', false);
      this.button.classList.remove('loading');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }
  }

  appendResultNode(text) {
    const li = document.createElement("li");
    const node = document.createTextNode(text);
    li.appendChild(node);
    this.resultsList.appendChild(li);
  }

  handleResultsList(list) {
    this.resultsList.innerHTML = '';
    for(var key in list) {
      if(Array.isArray(list[key])) {
        list[key].forEach((item) => {
          if(typeof item === 'object') {
            const li = document.createElement("li");
            const spanPrice = document.createElement("span");
            spanPrice.classList.add('price');
            const span = document.createElement("span");
            span.classList.add('cart-item__price', 'heading-font');
            const text = item.presentment_name + ': ';
            span.innerHTML = Shopify.showPrice(item.price * 100);
            spanPrice.append(span);
            const node = document.createTextNode(text);
            li.appendChild(node);
            li.appendChild(spanPrice);
            this.resultsList.appendChild(li);
          } else {
            this.appendResultNode(item);
          }
        });
      } else {
        this.appendResultNode(list[key]);
      }
    }
    this.resultsTag.classList.remove('hidden');
  }

  handleErrorResponse(errors) {
    this.showingErrors = true;
    this.resultsErrorHeading.classList.remove('hidden');
    this.resultsSuccessHeading.classList.add('hidden');
    this.handleResultsList(errors);
  }

  async checkDeliveryDate(pincode) {
    try {
      const params = new URLSearchParams({
        origin_pin: this.ORIGIN_PIN,
        destination_pin: pincode,
        mot: 'S',
        pdt: 'B2C',
        expected_pickup_date: this.getExpectedPickupDate()
      });

      this.log('Making Delhivery API request with params:', {
        origin_pin: this.ORIGIN_PIN,
        destination_pin: pincode,
        mot: 'S',
        pdt: 'B2C',
        expected_pickup_date: this.getExpectedPickupDate()
      });

      const apiUrl = `https://delhivery-server-proxy-umber.vercel.app/api/tat?${params}`;
      this.log('Delhivery API URL:', apiUrl);

      const response = await fetch(apiUrl, {
        headers: {
          'Authorization': `Token ${this.DELHIVERY_API_TOKEN}`,
        }
      });

      this.log('Delhivery API Response Status:', response.status);
      const data = await response.json();
      this.log('Delhivery API Response Data:', JSON.stringify(data, null, 2));

      if (data.success && data.data?.expected_delivery_date) {
        const deliveryDate = new Date(data.data.expected_delivery_date);
        const formattedDate = deliveryDate.toLocaleDateString('en-IN', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });

        this.log('Delivery date calculated:', {
          raw: data.data.expected_delivery_date,
          formatted: formattedDate,
          tat: data.data.tat
        });

        return {
          success: true,
          date: formattedDate,
          tat: data.data.tat
        };
      }

      return {
        success: false,
        error: 'Could not calculate delivery date'
      };
    } catch (error) {
      this.log('Delhivery API Error:', {
        message: error.message,
        stack: error.stack,
        error
      });
      return {
        success: false,
        error: error.message
      };
    }
  }

  getExpectedPickupDate() {
    const date = new Date();
    date.setDate(date.getDate() + this.AVERAGE_PICKUP_DAYS);
    return date.toISOString().split('T')[0] + ' 10:00';
  }

  getIconSVG(type) {
    if (type === 'success') {
      return `
        <svg style="vertical-align: middle; margin-right: 5px;" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 1.33334C4.32 1.33334 1.33333 4.32001 1.33333 8.00001C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 8 1.33334ZM8 13.3333C5.06 13.3333 2.66667 10.94 2.66667 8.00001C2.66667 5.06001 5.06 2.66668 8 2.66668C10.94 2.66668 13.3333 5.06001 13.3333 8.00001C13.3333 10.94 10.94 13.3333 8 13.3333ZM11.0067 5.72668L6.66667 10.0667L4.99333 8.40001L4.16667 9.22668L6.66667 11.7267L11.8333 6.56001L11.0067 5.72668Z" fill="#2e7d32"/>
        </svg>
      `;
    }
    // error icon (cross in circle)
    return `
      <svg style="vertical-align: middle; margin-right: 5px;" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="6.6667" stroke="#d32f2f" stroke-width="1.3333"/>
        <path d="M5.333 5.333 L10.667 10.667 M10.667 5.333 L5.333 10.667" stroke="#d32f2f" stroke-width="1.3333" stroke-linecap="round"/>
      </svg>
    `;
  }

  normalizeStateName(name) {
    if (!name) return '';
    return String(name)
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z\s]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  isCashOnDeliveryAvailable() {
    const provinceRaw = this.addressProvinceSelect && this.addressProvinceSelect.value;
    const province = this.normalizeStateName(provinceRaw);
    if (!province) return true;

    const notAvailable = new Set([
      'andaman and nicobar islands',
      'assam',
      'dadra and nagar haveli', // common spelling
      'dadar and nagar haveli', // user-provided spelling
      'daman and diu',
      'dadra and nagar haveli and daman and diu', // merged ut name
      'jammu and kashmir',
      'ladakh',
      'lakshadweep',
      'lakshdweep', // user-provided spelling
      'manipur',
      'meghalaya',
      'mizoram',
      'nagaland',
      'sikkim',
      'tripura'
    ]);

    return !notAvailable.has(province);
  }

  getExtraMessagesHTML() {
    const codAvailable = this.isCashOnDeliveryAvailable();
    const codText = codAvailable ? 'Pay on delivery Available.' : 'Pay on delivery Not available.';
    const codColor = codAvailable ? '#2e7d32' : '#d32f2f';

    return `
      <div style="margin-top: 8px; color: #2e7d32;">
        ${this.getIconSVG('success')}7 days delivery & replacement Available.
      </div>
      <div style="margin-top: 4px; color: ${codColor};">
        ${this.getIconSVG(codAvailable ? 'success' : 'error')}${codText}
      </div>
    `;
  }

  appendDeliveryDateNode(deliveryInfo) {
    const li = document.createElement("li");
    li.style.marginTop = '10px';
    li.style.paddingTop = '10px';
    li.style.listStyle = 'none';

    if (deliveryInfo.success) {
      li.innerHTML = `
        <div style="color: #2e7d32;">
          <svg style="vertical-align: middle; margin-right: 5px;" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 1.33334C4.32 1.33334 1.33333 4.32001 1.33333 8.00001C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 8 1.33334ZM8 13.3333C5.06 13.3333 2.66667 10.94 2.66667 8.00001C2.66667 5.06001 5.06 2.66668 8 2.66668C10.94 2.66668 13.3333 5.06001 13.3333 8.00001C13.3333 10.94 10.94 13.3333 8 13.3333ZM11.0067 5.72668L6.66667 10.0667L4.99333 8.40001L4.16667 9.22668L6.66667 11.7267L11.8333 6.56001L11.0067 5.72668Z" fill="#2e7d32"/>
          </svg>
          Expected delivery by ${deliveryInfo.date}
        </div>
        ${this.getExtraMessagesHTML()}
      `;
    } else {
      li.innerHTML = `
        <div style="color: #d32f2f;">
          <svg style="vertical-align: middle; margin-right: 5px;" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 1.33334C4.32 1.33334 1.33333 4.32001 1.33333 8.00001C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 8 1.33334ZM8.66667 11.3333H7.33333V10H8.66667V11.3333ZM8.66667 8.66668H7.33333V4.66668H8.66667V8.66668Z" fill="#d32f2f"/>
          </svg>
          Sorry, delivery date calculation failed. Please try again.
        </div>
        ${this.getExtraMessagesHTML()}
      `;
    }

    this.resultsList.appendChild(li);
  }

  async handleSuccessResponse(list) {
    this.showingErrors = false;
    this.resultsSuccessHeading.classList.remove('hidden');
    this.resultsErrorHeading.classList.add('hidden');
    this.handleResultsList(list);

    // Add delivery date calculation
    const pincode = this.addressZipInput.value;
    if (pincode && pincode.length === 6) {
      const deliveryInfo = await this.checkDeliveryDate(pincode);
      this.appendDeliveryDateNode(deliveryInfo);
    }
  }

  hideErrorsTag() {
    if(this.showingErrors) {
      this.resultsTag.classList.add('hidden');
      this.showingErrors = false;
    }
  }

  onButtonClick(event) {
  	if (this.button.classList.contains('loading')) return;

    this.startLoading();
  	
    const params = {
    	shipping_address: {
    		country: this.addressCountrySelect.value,
	    	province: this.addressProvinceSelect.value,
	    	zip: this.addressZipInput.value
    	}
    };

    const body = JSON.stringify(params);
    fetch(`${routes.cart_url}/prepare_shipping_rates.json`, {...fetchConfig('json', 'POST'), ...{ body }})
    .then((response) => response.json())
    .then((response) => {
      if(response == null || response.ok) {
        fetch(`${routes.cart_url}/async_shipping_rates.json?` + this.serialize(params), {...fetchConfig('json', 'GET'), ...{}})
        .then((finalResponse) => finalResponse.json())
        .then((finalResponse) => {
          this.handleSuccessResponse(finalResponse);
        })
        .finally(() => {
          this.needEndLoading = true;
          this.endLoading();
        });
      } else {
        this.needEndLoading = true;
        this.handleErrorResponse(response);
      }
    })
    .catch((e) => {
      this.handleErrorResponse(e);
      this.needEndLoading = true;
    })
    .finally(() => {
      this.endLoading();
    });
  }

  log(...args) {
    if (this.debug) {
      console.log('[ShippingCalculator]', ...args);
    }
  }
}

customElements.define('shipping-calculator', ShippingCaculator);